import React from "react";

export default function UsdaBanner() {
  return (
    <section
      className="sd-usda"
      style={{ backgroundImage: "url('/images/firebackdrop.jpg')" }}
      data-testid="usda-banner"
    >
      <h2>100% USDA QUALITY</h2>
      <p className="mt-4 max-w-2xl mx-auto">
        Sub Delicious serves only the finest meats from
        <br /> the United States — be it Angus, Buffalo, or Prime beef.
      </p>
    </section>
  );
}
